module.exports = __webpack_public_path__ + "img/gongan.3c51d8bf.png";